import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import CssBaseline from '@mui/material/CssBaseline';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import App from './App';
import ErrorBoundary from './components/ErrorBoundary';
import { installChunkErrorReload } from './utils/chunkReload';

// A deploy renames every hashed bundle, so a tab open across one will 404 on
// the next lazily-loaded route. Recover by reloading rather than showing a
// blank page. Installed before render so it also covers the initial load.
installChunkErrorReload();

// Create Material-UI theme
const theme = createTheme({
  palette: {
    mode: 'light',
    primary: {
      main: '#1976d2',
    },
    secondary: {
      main: '#dc004e',
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        {/* Outside App so it also catches failures in the lazy route Suspense */}
        <ErrorBoundary>
          <App />
        </ErrorBoundary>
      </ThemeProvider>
    </BrowserRouter>
  </React.StrictMode>
);
